import { listarMovimentos } from '../../../../api/movimentoListagem';
import { contextoMovimento, parametrosConferencia } from './contextoMovimento';
// src/components/pages/Movimento/list/IndexPage.js
import React, { useEffect, useMemo, useState, useContext, useCallback } from 'react';
import { Context } from '../../../../context/UserContext';

import { useDispatch } from 'react-redux';
import { selectComponent, clearSelectedComponent } from '../../../../store/reducers/actions';

import { useLocation } from 'react-router-dom';
import { useNavigateParams } from '../../../../hooks/useNavigateParams';
import { MaterialReactTable } from 'material-react-table';

import ResponsiveToolbarActions from '../../../layout/ResponsiveToolbarActions';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../../form/tableThemeCustom';

// novo modelo mrt
import { getColumnsByOperacao } from '../mrt/getColumnsByOperacao';
import { getRowActionsContent } from '../mrt/helpers/getRowActionsContent';
import { getToolbarActions } from '../mrt/helpers/getToolbarActions';
import { getMRTDefaultProps } from '../../../../helpers/mrt/getMRTDefaultProps';
import { useMediaQuery } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage';

//helpers
import { getEmpresaScope } from '../../../../helpers/sessionEmpresa';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import CustomDialog from '../../../layout/CustomDialog';

//api's
import CRUDsAPI from '../../../../api/CRUDs';
import { relatorios } from '../../../../api/relatorios';
import * as EmpresaAPI from '../../../../api/empresa';
import * as OperacaoAPI from '../../../../api/operacao';
import * as TransformaMovimentosAPI from '../../../../api/transformaMovimentos';
import * as GrupoAPI from '../../../../api/grupo';

// hooks
import DialogComprovantes from '../Comprovantes/DialogComprovantes';
import { useMovimentoComprovantesModule } from '../Comprovantes/modules/useComprovantesModule';

/* util */
import { obterDestinoRelatorio } from '../../../../utils/relatorios/obterDestinoRelatorio';
import {
    obterPermissoesUsuario,
    printPdf,
    precisaCorrigirDataColumnFiltersObjeto,
    corrigirDataColumnFiltersObjeto,
} from '../../../../utils/funcoes';
import { obterInicioEFimDoMes } from '../../../../utils/financeiro';

import { resolveMovimentoListBoot } from '../mrt/resolveMovimentoListBoot';
import { useMRTState } from '../../../../hooks/useMRTState';
import {
    podeImprimir,
    podeTransformar,
    podeCancelarMovimento,
    podeEditarMovimento,
    podeImprimirMovimento,
    podeIncluir,
    //relatórios
    podeImprimirAnalitico,
    podeImprimirGerencia,
    podeImprimirSintetico,
} from '../../../../hooks/usePermisionMRT';

import { OPERACAO_SIGLAS, MOVIMENTO_DEFAULTS } from '../shared/constants';
import { getDocumentoIcon } from '../shared/helpers/documentos';

import {
    Box,
    Paper,
    IconButton,
    Tooltip,
    Select,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';

const currency = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

const Index = () => {
    const classificacaoConferencia = 'menu';
    const [dados, setDados] = useState([]);
    const [token] = useState(localStorage.getItem('token')) || '';

    const [operacao, setOperacao] = useState({});
    const [operacaoParametros, setOperacaoParametros] = useState({});
    const [operacaoParametrosDocumentos, setOperacaoParametrosDocumentos] = useState([]);

    const [optionsEmpresa, setEmpresa] = useState([]);

    //configura a formatação dos decimais
    const utiliza3digitos = operacaoParametros.utiliza3digitos;
    const curvaABC = operacaoParametros.curvaABC; //permite ver o relatorio de curvaABV nos movimentos
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();

    const hoje = new Date(); // Hoje
    const { primeiroDia, ultimoDia } = obterInicioEFimDoMes(hoje);
    const { parametro } = useContext(Context);

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const location = useLocation();

    const newUrlParams = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams;
    }, [location.search]);
    const [urlParams, setUrlParams] = useState(new URLSearchParams(window.location.search));

    /* para a select de varios componentes */
    const dispatch = useDispatch();

    const pathname = '/Movimento/CreateOrEdit';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || MOVIMENTO_DEFAULTS.BTN_TEXT_CADASTRAR;
    const natureza = urlParams.get('natureza');
    const origem = urlParams.get('origem') || '';

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
        natureza: natureza,
        origem: origem,
    });

    const numberFormatter = useMemo(() => {
        const casas = operacaoParametros?.utiliza3digitos ? 3 : 2;

        return new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            minimumFractionDigits: casas,
            maximumFractionDigits: casas,
        });
    }, [operacaoParametros?.utiliza3digitos]);

    //identifica o tipo de parceiro pela operação
    let parceiroTipo = 'Cliente';

    if (operacao.entrada === true) {
        parceiroTipo = 'Fornecedor';
    } else if (operacao.industria === true) {
        parceiroTipo = 'Parceiro';
    } else if (operacao.manutencao === true) {
        parceiroTipo = 'Parceiro';
    } else if (operacao.saida === true) {
        parceiroTipo = 'Cliente';
    } else if (operacao.servico === true) {
        parceiroTipo = 'Parceiro';
    } else if (operacao.locacao) {
        parceiroTipo = 'Locador';
    }

    //dialog customizado
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [dialogFuncao, setDialogFuncao] = useState();
    const [selectedOption, setSelectedOption] = useState('');
    //servi parar evitar duplicidade na transformação
    const [confirmLoading, setConfirmLoading] = useState(false);

    const [optionsSituacao, setSituacao] = useState([]);
    const [optionsGrupo, setGrupo] = useState([]);

    const [mrtBooted, setMrtBooted] = useState(false);

    const movimentoListBoot = useMemo(() => {
        if (!operacao || !operacao.sigla) return null;

        return resolveMovimentoListBoot({
            operacao,
            profile: null, // ou o profile real, se você já tiver aqui
            parametro,
            primeiroDia,
            ultimoDia,
            origem,
        });
    }, [operacao, parametro, primeiroDia, ultimoDia, origem]);

    const mrt = useMRTState({
        storageKey: `movimento:v2:${contextoMovimento(location.search, empresaId, pessoaId)}:${classificacaoConferencia}`,
        pageIndexDefault: 0,
        pageSizeDefault: parametro?.paginacao || 10,
    });

    const getMovimentoMRTParams = ({ mrt, operacao, natureza } = {}) => {
        const offset = mrt.pagination.pageIndex * mrt.pagination.pageSize;
        const limit = mrt.pagination.pageSize;

        return {
            offset,
            limit,
            start: offset,
            size: limit,

            filterFns: JSON.stringify(mrt.columnFilterFns ?? {}),
            filters: JSON.stringify(mrt.columnFilters ?? []),
            filtersMode: JSON.stringify(mrt.columnFilterFns ?? {}),
            globalFilter: mrt.globalFilter ?? '',
            sorting: JSON.stringify(mrt.sorting ?? []),

            ...parametrosConferencia(li, origem, classificacaoConferencia),
            operacaoId: operacao?.id,
            operacaoSigla: operacao?.sigla,
            natureza: natureza,
        };
    };

    useEffect(() => {
        if (!mrtBooted) return;

        const semOrigem = !origem || origem === 'null' || origem === '';
        const novoValor = semOrigem ? '' : origem;
        const novoModo = semOrigem ? 'empty' : 'equals';

        const filtroAtual = Array.isArray(mrt.columnFilters) ? mrt.columnFilters.find((f) => f.id === 'origem') : null;

        const modoAtual = mrt.columnFilterFns?.origem;

        const mesmoValor = (filtroAtual?.value ?? '') === novoValor;
        const mesmoModo = modoAtual === novoModo;

        if (mesmoValor && mesmoModo) return;

        mrt.setColumnFilters((prev) => {
            const filters = Array.isArray(prev) ? [...prev] : [];
            const index = filters.findIndex((f) => f.id === 'origem');

            if (index >= 0) {
                filters[index] = { id: 'origem', value: novoValor };
            } else {
                filters.push({ id: 'origem', value: novoValor });
            }

            return filters;
        });

        if (typeof mrt.setColumnFiltersMode === 'function') {
            mrt.setColumnFiltersMode((prev) => ({
                ...(prev || {}),
                origem: novoModo,
            }));
        }

        mrt.setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
    }, [origem, mrtBooted, mrt.columnFilters, mrt.columnFilterFns]);
    useEffect(() => {
        if (mrtBooted) return;
        if (!movimentoListBoot) return;

        const dataFilter = Array.isArray(mrt.columnFilters) ? mrt.columnFilters.find((f) => f.id === 'data') : null;

        const hasDateRange =
            dataFilter &&
            Array.isArray(dataFilter.value) &&
            dataFilter.value.length === 2 &&
            dataFilter.value[0] &&
            dataFilter.value[1];

        const hasDateFilterFn = mrt.columnFilterFns?.data === 'between';
        const hasSorting = Array.isArray(mrt.sorting) && mrt.sorting.length > 0;

        let changed = false;

        if (!hasDateFilterFn) {
            if (typeof mrt.setColumnFiltersMode === 'function') {
                mrt.setColumnFiltersMode(movimentoListBoot.columnFilterFns || {});
            }
            changed = true;
        }

        if (!hasDateRange) {
            mrt.setColumnFilters(movimentoListBoot.columnFilters || []);
            changed = true;
        }

        if (!hasSorting && Array.isArray(movimentoListBoot.sorting) && movimentoListBoot.sorting.length > 0) {
            mrt.setSorting(movimentoListBoot.sorting);
            changed = true;
        }

        if (changed) return;

        setMrtBooted(true);
    }, [mrtBooted, movimentoListBoot, mrt.columnFilters, mrt.columnFilterFns, mrt.sorting]);

    // corrigir o formato da data no mrt
    useEffect(() => {
        if (!precisaCorrigirDataColumnFiltersObjeto(mrt.columnFilters)) return;

        mrt.setColumnFilters(corrigirDataColumnFiltersObjeto(mrt.columnFilters));
    }, [mrt.columnFilters]);

    //carrega a página
    const fetchData = useCallback(
        async (operacao) => {
            if (!operacao) return;

            const filtroOrigem = Array.isArray(mrt.columnFilters) ? mrt.columnFilters.find((f) => f.id === 'origem') : null;

            const modoOrigem = mrt.columnFilterFns?.origem;
            const valorOrigem = filtroOrigem?.value ?? '';

            const origemEhVazia = !origem || origem === 'null' || origem === '';
            const estadoOrigemInconsistente =
                (origemEhVazia && modoOrigem !== 'empty') ||
                (!origemEhVazia && modoOrigem !== 'equals') ||
                String(valorOrigem ?? '') !== String(origemEhVazia ? '' : origem);

            if (estadoOrigemInconsistente) {
                console.info('fetchData cancelado por estado transitório de origem', {
                    origem,
                    valorOrigem,
                    modoOrigem,
                });
                return;
            }

            if (!dados.length) {
                mrt.setIsLoading(true);
            } else {
                mrt.setIsRefetching(true);
            }

            let response;

            try {
                const filtros = getMovimentoMRTParams({ mrt, operacao, natureza });

                response = await listarMovimentos(filtros);

                setDados(response?.data?.data || []);
                mrt.setRowCount(response?.data?.meta?.totalRowCount || 0);
                mrt.setIsError(false);
            } catch (error) {
                console.error('Erro ao buscar dados:', error);
                setDados([]);
                mrt.setRowCount(0);
                setFlashMessage(error?.response?.data?.message || 'Não foi possível consultar os movimentos.', 'warning');
                mrt.setIsError(true);
            } finally {
                mrt.setIsLoading(false);
                mrt.setIsRefetching(false);
            }
        },
        [
            mrt.pagination.pageIndex,
            mrt.pagination.pageSize,
            mrt.columnFilters,
            mrt.columnFilterFns,
            mrt.globalFilter,
            mrt.sorting,
            natureza,
            origem,
            li,
            classificacaoConferencia,
        ]
    );
    //Consultas no backend
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(empresaId);

        // Extrai apenas os campos desejados
        const mappedResult = result.map((emp) => ({
            id: emp.id,
            value: emp.nomeFantasia,
            label: emp.nomeFantasia,
        }));

        setEmpresa(mappedResult);
    };
    /* consulta a situação e centro de custo considerando a operação */
    const consultaSituacao = async (obj) => {
        const { operacaoParametroId } = obj;

        try {
            const result = await OperacaoAPI.obterOperacaoSituacaoByOpParamId(obj);

            //  padroniza a resposta para o select
            const mappedResult = result.situacoes.map((x) => ({
                value: x.descricao,
                label: x.descricao,
            }));

            setSituacao(mappedResult ?? []);
        } catch (error) {
            console.error('Erro ao consultar situação:', error);
        }
    };
    const consultaGrupo = async (obj) => {
        try {
            const result = await GrupoAPI.gruposByEmpresaId(obj);
            //  padroniza a resposta para o select
            const mappedResult = result.map((x) => ({
                value: x.descricao,
                label: x.descricao,
            }));

            setGrupo(mappedResult);
        } catch (error) {
            console.error('Erro ao consultar grupo:', error);
        }
    };

    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
        }
    }, [token, navigate]);

    //boot
    useEffect(() => {
        consultaGrupo({ produto: true });
    }, []);
    useEffect(() => {
        if (!operacao?.id) return;
        if (!mrtBooted) return;

        fetchData(operacao);
    }, [operacao, mrtBooted, fetchData]);

    useEffect(() => {
        operacao && retornaOperacaoParametros(operacao.id, parametro.empresaId);
    }, [operacao]);

    // Separar a chamada do retornaOperacao e fetchdata em um useEffect separado
    useEffect(() => {
        const carregarOperacao = async () => {
            await retornaOperacao(operacaoUUID);
        };

        if (operacaoUUID) {
            carregarOperacao();
        }

        // eslint-disable-next-line
    }, [operacaoUUID]);

    const [custoFilialAtivo, setCustoFilalAtivo] = useState(false);

    useEffect(() => {
        if (!pessoaId || !empresaId || !ul || !li) return;
        obterPermissoesUsuario(pessoaId, empresaId, ul, li);
    }, [pessoaId, empresaId, ul, li]);

    useEffect(() => {
        const cf = mrt.columnFilters.find((f) => f.id === 'custoFilial')?.value === '1';
        setCustoFilalAtivo(cf);

        /* Inicio da função para renderizar a página */
        // Verifica se os urlParams atuais são diferentes dos novos urlParams
        const areUrlParamsDifferent = () => {
            const currentKeys = Array.from(urlParams.keys());
            const newKeys = Array.from(newUrlParams.keys());

            // Verifica se o número de chaves é diferente
            if (currentKeys.length !== newKeys.length) {
                return true;
            }

            // Verifica se as chaves são diferentes
            for (let i = 0; i < currentKeys.length; i++) {
                if (currentKeys[i] !== newKeys[i]) {
                    return true;
                }
            }

            // Verifica se os valores são diferentes
            for (const key of currentKeys) {
                const currentValue = urlParams.get(key);
                const newValue = newUrlParams.get(key);

                if (currentValue !== newValue) {
                    return true;
                }
            }

            return false;
        };

        if (areUrlParamsDifferent()) {
            setUrlParams(newUrlParams);
        }
    }, [
        token,
        mrt.columnFilterFns,
        mrt.columnFilters,
        mrt.globalFilter,
        mrt.pagination.pageIndex,
        mrt.pagination.pageSize,
        mrt.sorting,
        //função para renderizar
        location.search,
        urlParams,
        ul,
        li,
        operacaoUUID,
        newUrlParams,
        natureza,
        origem,
    ]);

    useEffect(() => {
        if (!empresaId) return;

        consultaEmpresa();
    }, [empresaId]);

    useEffect(() => {
        if (!empresaId || !operacaoUUID) return;

        const run = async () => {
            try {
                const result = await OperacaoAPI.situacaoByOperacao({
                    uuid: operacaoUUID,
                    empresaId,
                });

                const options = (result || []).map((x) => ({
                    value: x.descricao,
                    label: x.descricao,
                }));

                setSituacao(options);

                // sanitiza filtro salvo automaticamente (remove "Aberto" se não existir)
                const valid = new Set(options.map((o) => String(o.value)?.toLowerCase()));
                mrt.setColumnFilters((prev) =>
                    Array.isArray(prev)
                        ? prev.filter((f) => {
                              if (f.id !== 'Situacao.descricao') return true;
                              const v = String(f.value ?? '')?.toLowerCase();
                              return !v || valid.has(v);
                          })
                        : prev
                );
            } catch (e) {
                console.error('Erro ao consultar situação:', e);
                setSituacao([]); // opcional
            }
        };

        run();
    }, [empresaId, operacaoUUID, origem]);

    useEffect(() => {
        if (!operacaoParametros.id) {
            return;
        }
        consultaSituacao({ operacaoParametroId: operacaoParametros.id });
    }, [operacaoParametros]);

    //funções do dialog
    const handleOpenDialog = (row, funcao) => {
        setOpenDialog(true);
        setSelectedRow(row);
        setDialogFuncao(funcao);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedOption(''); // Reseta a opção ao fechar
        setConfirmLoading(false);
    };

    const handleConfirmDialog = async (row) => {
        setConfirmLoading(true); // Ativa loading
        // Verifique se há uma linha selecionada
        let msgType = 'success';

        if (dialogFuncao === 'transformar') {
            const urlSearchParams = new URLSearchParams({
                start: `${mrt.pagination.pageIndex * mrt.pagination.pageSize}`,
                size: `${mrt.pagination.pageSize}`,
                filters: JSON.stringify(mrt.columnFilters ?? []),
                filtersMode: JSON.stringify(mrt.columnFilterFns ?? {}),
                globalFilter: mrt.globalFilter ?? '',
                sorting: JSON.stringify(mrt.sorting ?? []),
                tipo: tipo ?? 'Entrada',
                operacaoParaTransformarUUID: selectedOption,
            });

            const response = await TransformaMovimentosAPI.transformaMovimentos(
                'transformaMovimentos',
                urlSearchParams,
                selectedRow
            );

            //obtem o motivo pelo qual o movimento não foi transformado
            const mensagensErro = (response.data.detalhes || []).map((e) => `Item ${e.index + 1}: ${e.message}`).join('\n');

            //quando existe movimento não transformado o sistema aumenta o tempo para o usuário fazer a leitura
            const tempo = mensagensErro.length > 0 ? 10 : 3;
            const detalhes = mensagensErro.length > 0 ? '\nBloqueados:\n' + mensagensErro : '\nSem movimentos bloqueados';

            setFlashMessage(response.data.message + ' ' + detalhes, response.data.type, tempo);

            fetchData(operacao);
        } else if (dialogFuncao === 'cancelar' && selectedRow) {
            try {
                const response = await CRUDsAPI.movimento.deletar(selectedRow);
                setFlashMessage(response.data.message, msgType);

                // atualizar a grid
                fetchData(operacao);
            } catch (error) {
                msgType = 'error';
                console.error(error);
                setFlashMessage(error.response.data.message, msgType);
            }
        }

        setOpenDialog(false);
        setConfirmLoading(false);
    };

    // hooks
    const comprovantesModule = useMovimentoComprovantesModule({
        uuid: selectedRow?.id,
        open: openDialog && dialogFuncao === 'comprovantes',
        setFlashMessage,
    });

    async function retornaOperacao(uuid) {
        try {
            const data = await OperacaoAPI.operacao(uuid);
            setOperacao(data);

            return data;
        } catch (erro) {
            // Lide com o erro
            console.error(erro);
        }
    }

    async function retornaOperacaoParametros(operacaoId, empresaId) {
        try {
            const data = await OperacaoAPI.retornaOperacaoParametros(operacaoId, empresaId);
            setOperacaoParametros(data);
            setOperacaoParametrosDocumentos(data.operacaoParametrosDocumentos || []);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    const columns = useMemo(() => {
        if (!operacao || !operacao?.sigla) return [];
        return getColumnsByOperacao({ operacao, parceiroTipo, optionsSituacao, optionsGrupo, optionsEmpresa });
    }, [operacao, parceiroTipo, optionsSituacao, optionsGrupo, optionsEmpresa]);

    //funções do toolbar

    // Handlers específicos da tela
    const handleNovo = () => {
        params.delete('uuid');
        params.set('btnText', 'Cadastrar');
        navigate(pathname, params);
    };

    const handleTransformar = (table) => {
        dispatch(clearSelectedComponent());
        const uuids = table.getSelectedRowModel().flatRows.map((row) => row.id);
        dispatch(selectComponent(uuids));

        const dadosUUIDs =
            uuids.length > 0
                ? dados.filter((item) => uuids.includes(item.uuid) && item.transformado === false)
                : dados.filter((item) => item.transformado === false);

        if (dadosUUIDs.length === 0) {
            setFlashMessage('Não existe registros para transformar!', 'warning');
            table.resetRowSelection();
            return;
        }

        handleOpenDialog(uuids, 'transformar');
        table.resetRowSelection();
    };

    //relatorios padrões
    const handleRelatorios = async (objeto) => {
        const filtros = mrt.columnFilters ?? [];
        const { caminho, url } = obterDestinoRelatorio(objeto, filtros);

        //const caminho = objeto.caminho;
        //const url = objeto.url;
        const obj = {
            analitico: objeto.analitico,
            natureza: objeto.natureza,
            operacao,
            filters: JSON.stringify(mrt.columnFilters ?? []),
            filtersMode: JSON.stringify(mrt.columnFilterFns ?? {}),
            sorting: JSON.stringify(mrt.sorting ?? []),
        };

        const response = await relatorios(caminho, url, obj);
        printPdf(response.data);
    };

    //relatórios que dependem de seleção na grid
    const handleComandas = async (table) => {
        dispatch(clearSelectedComponent());
        const uuids = table.getSelectedRowModel().flatRows.map((row) => row.id);
        dispatch(selectComponent(uuids));

        const dadosUUIDs =
            uuids.length > 0
                ? dados.filter((item) => uuids.includes(item.uuid) && item.transformado === false)
                : dados.filter((item) => item.transformado === false);

        if (dadosUUIDs.length === 0) {
            setFlashMessage('Não existe registros para transformar!', 'warning');
            table.resetRowSelection();
            return;
        }

        const caminho = 'ticketSelfServiceRestaurante';
        const url = 'ticketSelfServiceRestaurante';
        const obj = {
            utiliza3digitos: utiliza3digitos,
            uuids: dadosUUIDs.map((item) => item.uuid),
            operacaoId: operacao.id,
            empresaId: empresaId,
            filters: JSON.stringify(mrt.columnFilters ?? []),
            filtersMode: JSON.stringify(mrt.columnFilterFns ?? {}),
            sorting: JSON.stringify(mrt.sorting ?? []),
        };

        const response = await relatorios(caminho, url, obj);
        printPdf(response.data);
        table.resetRowSelection();
    };
    /* modo tema */
    const theme = tableThemeCustom();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const mrtDefault = getMRTDefaultProps({
        mrt,
        parametro,
        isMobile,
    });

    return (
        <div>
            <div>
                {/* Modal de Exclusão */}
                {openDialog && dialogFuncao === 'cancelar' && (
                    <CustomDialog
                        title="Deletar Registro"
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}

                {/* Modal de Transformação */}
                {openDialog && dialogFuncao === 'transformar' && (
                    <CustomDialog
                        title="Escolha a Transformação"
                        content={
                            <Select
                                fullWidth
                                value={selectedOption || ''} // Garante que não seja undefined
                                onChange={(e) => {
                                    setSelectedOption(e.target.value);
                                }}
                            >
                                {operacaoParametros?.operacaoTransformacoes
                                    ?.filter((option) => {
                                        // 1) bloqueia FAT quando a origem for REQ
                                        if (origem === OPERACAO_SIGLAS.REQ && option?.Operacao?.sigla === 'FAT') {
                                            return false;
                                        }

                                        // 2) filtro por natureza
                                        if (!natureza || natureza === 'null') return true;
                                        return option.natureza === natureza; // aplica o filtro apenas se válido
                                    })
                                    .map((option) => (
                                        <MenuItem
                                            key={option.uuid}
                                            value={option.uuid}
                                            title={option.natureza ? 'natureza da operação ' + option.natureza : ''}
                                        >
                                            {option.Operacao.descricao}
                                        </MenuItem>
                                    ))}
                            </Select>
                        }
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                        disableConfirm={!selectedOption || confirmLoading}
                        loading={confirmLoading}
                    />
                )}

                {openDialog && dialogFuncao === 'comprovantes' && (
                    <DialogComprovantes
                        open={openDialog}
                        onClose={() => {
                            setOpenDialog(false);
                            setDialogFuncao(null);
                            setSelectedRow(null);
                        }}
                        {...comprovantesModule}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    {...mrtDefault}
                    columns={columns}
                    data={dados}
                    getRowId={(row) => row.uuid}
                    renderRowActions={({ row }) => {
                        const handleImprimir = async (documento, obj) => {
                            const caminho = documento.Documento.caminho;
                            const url = documento.Documento.funcao;

                            //com a modificação do relatorio basta enviar obj {uuid: obj.uuid}
                            //com isso diminuo a pesquisa na listagem melhorando a performance do sistema
                            const response = await relatorios(caminho, url, {
                                uuid: obj.uuid,
                                utiliza3digitos: utiliza3digitos,
                                operacaoId: operacao.id,
                                empresaId: empresaId,
                            });

                            //gera o pdf
                            printPdf(response.data);
                        };
                        const printEtiquetasGrande = async (obj) => {
                            // se obj for nulo, undefined, ou um objeto vazio, sai da função
                            if (!obj || Object.keys(obj).length === 0) {
                                console.warn('Nenhum dado para gerar etiqueta.');
                                setFlashMessage('Não é possível imprimir a etiqueta!', 'warning');
                                return;
                            }

                            const response = await relatorios('etiquetasGrande', 'etiquetasGrande', obj);

                            //gera o pdf
                            printPdf(response.data);
                        };

                        return getRowActionsContent({
                            row,
                            operacao,
                            origem,
                            operacaoParametrosDocumentos,
                            getDocumentoIcon,
                            handleImprimir,
                            printEtiquetasGrande,
                            handleOpenDialog,
                            navigate,
                            pathname,
                            params,
                        });
                    }}
                    renderTopToolbarCustomActions={({ table }) => {
                        const actions = getToolbarActions({
                            table,
                            operacao,
                            curvaABC,
                            natureza,
                            custoFilialAtivo,
                            handleNovo,
                            handleTransformar,
                            handleRelatorios,
                            handleComandas,
                            podeIncluir,
                            podeTransformar,
                            podeImprimir,
                            podeImprimirAnalitico,
                            podeImprimirSintetico,
                            podeImprimirGerencia,
                        });

                        return <ResponsiveToolbarActions actions={actions} />;
                    }}
                    renderDetailPanel={({ row }) => {
                        // ajuste os nomes conforme seu backend
                        const itens = row.original?.movimentoItems ?? [];

                        const totais = itens.reduce(
                            (acc, r) => {
                                acc.valorUnitario += Number(r.precoNegociado);
                                acc.descontoValor += Number(r.descontoValor);
                                acc.descontoFinanceiro += Number(r.descontoFinanceiro);
                                acc.valorTotal += Number(r.valorTotal);
                                return acc;
                            },
                            { valorUnitario: 0, descontoValor: 0, descontoFinanceiro: 0, valorTotal: 0 }
                        );

                        return (
                            <Box sx={{ p: 2 }}>
                                <Typography fontWeight={700} fontSize={16} mb={1}>
                                    Produtos do pedido
                                </Typography>

                                {itens.length === 0 ? (
                                    <Typography color="text.secondary">Nenhum produto no pedido.</Typography>
                                ) : (
                                    <TableContainer component={Paper} variant="outlined">
                                        <Table size="small" aria-label="produtos do pedido">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Código</TableCell>
                                                    <TableCell>Produto</TableCell>
                                                    <TableCell align="right">Qtd</TableCell>
                                                    <TableCell align="right">Vlr Unit.</TableCell>
                                                    <TableCell align="right">Desconto</TableCell>
                                                    <TableCell align="right">Desconto Financeiro</TableCell>
                                                    <TableCell align="right">Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itens.map((item) => {
                                                    const nome = item?.Produto?.descricao ?? '—';

                                                    return (
                                                        <TableRow key={item.uuid ?? item.id ?? nome}>
                                                            <TableCell align="center">{item?.Produto?.codigo}</TableCell>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <Typography fontWeight={600}>{nome}</Typography>
                                                                    {!!item.codigoBarras && (
                                                                        <Typography variant="caption" color="text.secondary">
                                                                            EAN: {item?.codigoBarras}
                                                                        </Typography>
                                                                    )}
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {numberFormatter.format(item.quantidade)}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {currency.format(item.precoNegociado)}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {item.valorDesconto > 0
                                                                    ? currency.format(item.descontoValor)
                                                                    : '—'}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {item.descontoFinanceiro > 0
                                                                    ? currency.format(item.descontoFinanceiro)
                                                                    : '—'}
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                {currency.format(item.valorTotal)}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                                <TableRow>
                                                    <TableCell colSpan={3} />
                                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                                        {currency.format(totais.valorUnitario)}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                                        {currency.format(totais.descontoValor)}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                                        {currency.format(totais.descontoFinanceiro)}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 700 }}>
                                                        {currency.format(totais.valorTotal)}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Box>
                        );
                    }}
                />
            </ThemeProvider>
        </div>
    );
};
// Remonta ao trocar o menu: impede respostas e filtros da tela anterior no novo contexto.
const MovimentoListPage = () => {
    const location = useLocation();
    const { empresaId, pessoaId } = getEmpresaScope();
    return <Index key={contextoMovimento(location.search, empresaId, pessoaId)} />;
};
export default MovimentoListPage;
